import * as React from 'react';
import { IgcCardActionsComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * A container component for card action items such as buttons or icon buttons.
 * Actions can be positioned at the start, center, or end of the container.
 * @slot start - Renders items at the beginning of the actions area.
 * @slot  - Renders items in the center of the actions area.
 * @slot end - Renders items at the end of the actions area.
 * @class
 */
export const IgrCardActions = /* @__PURE__ */ createComponent({
  tagName: 'igc-card-actions',
  displayName: 'IgrCardActions',
  elementClass: Component,
  react: React,
});

export type IgrCardActions = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrCardActionsModule = Component;
